import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DEFAULT_LANGUAGE, isSupportedLanguage } from './language.constants';

export const languageGuard: CanActivateFn = (route) => {
  const lang = route.paramMap.get('lang') ?? '';

  if (isSupportedLanguage(lang)) {
    return true;
  }

  const router = inject(Router);
  return router.createUrlTree([`/${DEFAULT_LANGUAGE}`]);
};
